import { SurveyFormOptionType } from '../../../interfaces/Element.interfaces';

export const SELL_TRACTOR_OPTION_VALUES = {
  YES: '예',
  NO: '아니오',
};

export const sellTractorSurveyOptionConstants: SurveyFormOptionType[] = [
  {
    value: SELL_TRACTOR_OPTION_VALUES.YES,
    label: '예) 전방 PTO 등',
  },
  {
    value: SELL_TRACTOR_OPTION_VALUES.NO,
    label: '옵션 없음',
  },
];

export const sellCombineSurveyOptionConstants: SurveyFormOptionType[] = [
  {
    value: SELL_TRACTOR_OPTION_VALUES.YES,
    label: '예) 드로퍼 등',
  },
  {
    value: SELL_TRACTOR_OPTION_VALUES.NO,
    label: '옵션 없음',
  },
];

export const sellTractorSurveyWorkingMachineConstants: SurveyFormOptionType[] = [
  {
    value: SELL_TRACTOR_OPTION_VALUES.YES,
    label: '예) 로타리, 집게 등',
  },
  {
    value: SELL_TRACTOR_OPTION_VALUES.NO,
    label: '작업기 없음',
  },
];

export const sellTractorSurveySteps = {
  STEP1: 1,
  STEP2: 2,
  STEP3: 3,
  STEP4: 4,
  STEP5: 5,
  STEP6: 6,
  STEP7: 7,
  STEP8: 8,
};
